(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bumpino-welcome-discount"]) return;
  try {
    
  (() => {
    const storageKey = 'bumpino.welcome10.seen.v1';
    const savedTime = () => {
      let timestamp = 0;
      for (const name of ['localStorage', 'sessionStorage']) {
        try { timestamp = Math.max(timestamp, Number(window[name].getItem(storageKey)) || 0); } catch {}
      }
      return timestamp;
    };
    const markSeen = () => {
      for (const name of ['localStorage', 'sessionStorage']) {
        try { window[name].setItem(storageKey, String(Date.now())); } catch {}
      }
    };
    const initialize = (scope) => {
      scope.querySelectorAll('[data-bumpino-welcome]').forEach((dialog) => {
        if (dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
        dialog.dataset.initialized = 'true';
        const editor = dialog.dataset.editor === 'true';
        const hideMs = Math.max(1, Number(dialog.dataset.hideHours) || 24) * 3600000;
        if (!editor && Date.now() - savedTime() < hideMs) return;
        let timer;
        let attempts = 0;
        let previousFocus;
        const dismiss = () => { if (dialog.open) dialog.close(); };
        const shop = dialog.querySelector('[data-bumpino-shop]');
        dialog.querySelectorAll('[data-bumpino-close]').forEach((button) => button.addEventListener('click', dismiss));
        shop?.addEventListener('click', dismiss);
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss();
        });
        dialog.addEventListener('close', () => {
          if (previousFocus instanceof HTMLElement && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
        });
        const show = () => {
          if (!dialog.isConnected || dialog.open) return;
          if (!editor && Date.now() - savedTime() < hideMs) return;
          const anotherOverlay = document.querySelector('dialog[open], .mfp-wrap, .t4s-drawer.is--opened, .t4s-drawer[aria-hidden="false"]');
          if (document.visibilityState === 'hidden' || anotherOverlay) {
            if (++attempts < 60) timer = window.setTimeout(show, 1000);
            return;
          }
          previousFocus = document.activeElement;
          dialog.showModal();
          if (!editor) markSeen();
        };
        timer = window.setTimeout(show, editor ? 0 : Math.max(0, Number(dialog.dataset.delay) || 8) * 1000);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(dialog)) { window.clearTimeout(timer); dismiss(); }
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
